<script lang="ts">
export default {
  name: "RightEvent",
};
</script>
<script setup lang="ts">
import { getAlarmList,deleteAlarmList,sendAlarmList } from "@/api/eventApi/index"
import { onMounted, onUnmounted } from 'vue'
import { useVueCesium } from 'vue-cesium'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'
import { store } from '@/store'
import { useFormatDate } from "@/hooks/userHookDate"

const $vc = useVueCesium()
const useDate = useFormatDate()

const page = ref({
  page: 1,
  size: 20,
});

const listTimer = ref()

const searchValue = ref({
  position: "",
  eventType: "",
  startTime: "2020-01-01",
  endTime: "",
  gatewaySn: "",
  jobId: ""
});

const warningList: any = ref([])

async function AlarmList() {
  if (searchValue.value.gatewaySn) {
    searchValue.value.startTime = ""
  }
  const params = { ...page.value, ...searchValue.value } as any;
  const result = await getAlarmList(params);
  warningList.value = result.list;
  store.informationListStore.informationStore().setWarningIcon(warningList.value)
  // console.log(warningList.value)
}

const popActive = ref(-1)
const entity = ref()
const warningBtn = (list: any, i: number) => {
  store.informationListStore.informationStore().setmapPopActive(false)
  if (popActive.value == i) {
    popActive.value = -1
    if (entity.value) {
      $vc.viewer.entities.remove(entity.value);
      store.informationListStore.informationStore().setWaringList({})
      store.informationListStore.informationStore().setmapPopActive(false)
    }
  } else {
    popActive.value = i
    flyToCamera(
      $vc.viewer,
      {
        position: Cesium.Cartesian3.fromDegrees(Number(list.lng)- 0.002, Number(list.lat) - 0.007, 500),
        heading: 6.563185307179586,
        pitch: -0.5001412827126326,
        roll: 6.283185307179586,
      }
    )
    // 定义点位坐标
    const position = Cesium.Cartesian3.fromDegrees(Number(list.lng), Number(list.lat), 0)
    if (entity.value) {
      $vc.viewer.entities.remove(entity.value);
    }
    // // 添加点位实体
    // entity.value = $vc.viewer.entities.add({
    //   position: position,
    //   billboard: {
    //     width: 109,
    //     height: 118,
    //     image: '/images/yujing-icon.png', // 图片路径
    //     scale: 0.5, // 图片大小
    //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM // 垂直对齐方式
    //   },
    // })
    store.informationListStore.informationStore().setmapPopActive(true)
    store.informationListStore.informationStore().setWaringList(list)
  }

  // setTimeout(()=>{
  //   popActive.value = true
  //   const positionPop =  $vc.viewer.scene.cartesianToCanvasCoordinates(
  //     position
  //   );
  //   console.log(positionPop)
  // },2000)
  // 视角定位到点位
  // $vc.viewer.zoomTo(entity);
}

const pushBtn = (list: any, i: number) => {
  sendAlarmList(list).then((res)=>{
    ElMessage.success("推送成功")
    AlarmList()
  })
}

const deletBtn = (list: any, i: number) => {
  deleteAlarmList(list.warningId).then((res)=>{
    ElMessage.success("删除成功")
    AlarmList()
  })
}

function dateStringToTimestamp(dateString:any) {
  return new Date(dateString).getTime();
}

// 计算属性来判断时间差是否小于半小时
const isWithinHalfHour = (timestamp:any) => {
  const now = new Date();
  const history = new Date(Number(timestamp));
  const difference = now.getTime() - history.getTime();
  const isLessThan30Minutes = difference < 30 * 60 * 1000; // 30分钟
  return isLessThan30Minutes;
};


watch(() => store.informationListStore.informationStore().taskList, (data:any, oldVal) => {
  searchValue.value.jobId = data.jobId
  searchValue.value.gatewaySn = data.dockSn
  if(listTimer.value){
    clearInterval(listTimer.value);
    listTimer.value = null
  }
  AlarmList()
}, {
    deep: true
})

watch(() => store.informationListStore.informationStore().dateValue, (data:any, oldVal) => {
  console.log(data)
  if(data){
    searchValue.value.startTime = data[0]
    searchValue.value.endTime = data[1]
  }else{
    searchValue.value.startTime = "2020-01-01"
    searchValue.value.endTime = ""
  }
  if(listTimer.value){
      clearInterval(listTimer.value);
      listTimer.value = null
    }
    AlarmList()
}, {
    deep: true
})

onMounted(() => {
  AlarmList()
  listTimer.value = setInterval(()=>{
    AlarmList()
  },10000)
})
onUnmounted(() => {
  clearInterval(listTimer.value);
  listTimer.value= null
  if (entity.value) {
    $vc.viewer.entities.remove(entity.value);
    store.informationListStore.informationStore().setmapPopActive(false)
    store.informationListStore.informationStore().setWaringList({})
  }
  store.informationListStore.informationStore().setWarningIcon([])
})
</script>

<template>
  <div class="right-event">
    <div class="event-box">
      <div class="small-title mt30">事件列表</div>
      <div class="event-list-bj">
        <div class="list-box" :class="{ 'list-box-active' : popActive === index }" v-for="(item, index) in warningList" @click="warningBtn(item, index)">
          <p>
            时间：
            <span style="color: #FFCC00;">{{ item.eventTime }}</span>
            <span v-if="isWithinHalfHour(dateStringToTimestamp(item.eventTime))" style="color: #FFCC00;">new</span>
          </p>
          <p>地点：{{ item.name }}</p>
          <p class="typeWord">类型：{{ item.eventType }}</p>
          <p class="pushBtn" @click.stop="pushBtn(item,index)">推送</p>
          <p class="deletBtn" @click.stop="deletBtn(item,index)">
            <img src="@/assets/images/cha.png" alt="">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.right-event {
  position: absolute;
  top: 7.5rem;
  right: 0;
  width: 21.1vw;
  height: 88vh;
  background: url("@/assets/images/right-monitor-bj.png") no-repeat center;
  background-size: 100% 100%;
  pointer-events: all;

  .event-box {
    .event-list-bj {
      width: 20vw;
      height: 78vh;
      margin: .625rem auto;
      overflow-y: auto;

      .list-box {
        width: 90%;
        height: 11vh;
        background-color: rgba(0, 0, 0, 0.32);
        margin: 0.6rem auto;
        border-radius: 10px;
        border: 2px solid #bcc5cb;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        cursor: pointer;
        position: relative;
        p {
          font-size: 1rem;
          color: #fff;
          margin: .1875rem 1.25rem;
          white-space: nowrap;
          /* 确保文本在一行内显示 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
          /* 使用省略号表示文本溢出 */
          line-height: normal;
          position: relative;

          span:nth-child(1) {
     
          }
        }

        .typeWord {
          width: 10vw;
          color: #00FFE5;
        }
        .pushBtn{
          position: absolute;
          right: 0;
          bottom: 0;
          border-radius: 6px;
          border: 1px solid #00FFE5;
          padding: 2px 5px;
          cursor: pointer;
        }
        .deletBtn{
          position: absolute;
          right: -15px;
          top: 0;
          cursor: pointer;
          width: 20px;
          height: 20px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .list-box-active{
        background-color: rgba(0, 0, 0, 1);
      }
    }
  }
}
</style>
